import { useState, useRef, useEffect } from "react";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";

import style from "./CustomCardsSwiper.module.css";

export default function CustomCardsSwiper(props) {
  class Card {
    constructor(x, y, scale, opacity, zIndex) {
      this.x = x;
      this.y = y;
      this.scale = scale;
      this.opacity = opacity;
      this.zIndex = zIndex;
      this.ease = "power2.out";
      this.duration = 0.2;
      this.rotateY = 0;
    }
  }

  const [count, setCount] = useState(0);
  const [cards, setCards] = useState([]);
  const [idSelectedCard, setIdSelectedCard] = useState(0);
  const [pointOfTouch, setPointOfTouch] = useState(0);
  const containerRef = useRef(null);

  const [cardsProps, setCardsProps] = useState([]);
  // let cardsProps = []

  const { contextSafe } = useGSAP({ scope: containerRef });

  const animate = contextSafe((card, properties) => {
    gsap.timeline().from(card, properties);
  });

  const initPos = contextSafe((card, properties) => {
    gsap.to(card, properties);
  });

  const cardOut = contextSafe((card, newCardsProps) => {
    const tl = gsap.timeline();

    tl.to(card, { x: card.offsetWidth * 0.8, scale: 0.5, rotateY: 30 });
    tl.to(card, { zIndex: newCardsProps[idSelectedCard].zIndex, duration: 0 });
    for (let i = 0; i < newCardsProps.length; i++) {
      if (i == idSelectedCard) {
        tl.to(cards[i], { ...newCardsProps[i].zIndex, duration: 0 });
        tl.to(cards[i], { ...newCardsProps[i], duration: 0.8 });
      } else {
        gsap.to(cards[i], { ...newCardsProps[i], duration: 0.5 });
      }
    }
  });

  const cardLeft = contextSafe((card, newCardsProps) => {
    const tl = gsap.timeline();
    tl.to(card, { x: card.offsetWidth * -0.8, scale: 0.5, rotateY: 30 });
    tl.to(card, { zIndex: newCardsProps[idSelectedCard].zIndex, duration: 0 });
    for (let i = 0; i < newCardsProps.length; i++) {
      if (i == idSelectedCard) {
        tl.to(cards[i], { ...newCardsProps[i].zIndex, duration: 0 });
        tl.to(cards[i], { ...newCardsProps[i], duration: 0.8 });
      } else {
        gsap.to(cards[i], { ...newCardsProps[i], duration: 0.5 });
      }
    }
  });

  function initCards(cards) {
    let newCards = cards;
    let cardsProps = [];
    for (let i = 0; i < newCards.length; i++) {
      if (i == idSelectedCard) {
        cardsProps.push(new Card(0, 0, 1, 1, newCards.length - i)); //notActiveCardsPosX - newCards[i].offsetWidth*0.5/2+(i*20)
      } else {
        cardsProps.push(new Card(10, 0, 1, 0.9, newCards.length - i));
      }

      // cardsProps.push(new Card(1, 1, 0.5))
    }
    setCardsProps(cardsProps);

    for (let i = 0; i < newCards.length; i++) {
      initPos(newCards[i], cardsProps[i]);
    }
    return newCards;
  }

  function changeCard(side) {
    // animate()
    let takeId = idSelectedCard;
    let prevId = idSelectedCard;
    let newCards = [...cards];
    let newCardsProps = [...cardsProps];

    if (side > 0) {
      let changeValue = newCardsProps[newCardsProps.length - 1];
      for (let i = newCardsProps.length - 1; i > 0; i--) {
        newCardsProps[i] = newCardsProps[i - 1];
      }
      newCardsProps[0] = changeValue;
      // if(idSelectedCard > 0 && idSelectedCard < newCardsProps.length-1){
      newCardsProps[idSelectedCard].x = -10;
      setCardsProps(newCardsProps);
      cardLeft(cards[idSelectedCard], newCardsProps);

      if (idSelectedCard == cards.length - 1) {
        setIdSelectedCard(0);
      } else {
        setIdSelectedCard((perv) => perv + 1);
      }
    } else if (side < 0) {
      let changeValue = newCardsProps[newCardsProps.length - 1];
      for (let i = newCardsProps.length - 1; i > 0; i--) {
        newCardsProps[i] = newCardsProps[i - 1];
      }
      newCardsProps[0] = changeValue;
      newCardsProps[idSelectedCard].x = 10;
      setCardsProps(newCardsProps);
      cardOut(cards[idSelectedCard], newCardsProps);
      if (idSelectedCard == cards.length - 1) {
        setIdSelectedCard(0);
      } else {
        setIdSelectedCard((perv) => perv + 1);
      }
    }
  }

  useEffect(() => {
    setCards((prev) => {
      return initCards(containerRef.current.children);
    });
  }, []);

  useEffect(() => {
    props.setRewardType(idSelectedCard);
  }, [idSelectedCard]);

  return (
    <div className={style["container-wrapper"]}>
      <div
        draggable="false"
        onMouseDown={(e) => {
          setPointOfTouch(e.clientX);
          // console.log('start')
        }}
        onMouseUp={(e) => {
          if (Math.abs(pointOfTouch - e.clientX) > 50) {
            changeCard(pointOfTouch - e.clientX);
          }
          // console.log(pointOfTouch - e.clientX)
        }}
        onTouchStart={(e) => {
          // console.log(e)
          setPointOfTouch(e.changedTouches[0].pageX);
          // console.log('start')
        }}
        onTouchEnd={(e) => {
          if (Math.abs(pointOfTouch - e.changedTouches[0].pageX) > 50) {
            changeCard(pointOfTouch - e.changedTouches[0].pageX);
          }
          // console.log(pointOfTouch - e.changedTouches[0].pageX)
        }}
        ref={containerRef}
        className={style["container"]}
      >
        {props.children.map((element) => {
          return <div className={style["card"]}>{element}</div>;
        })}

        {/* {props.children} */}
      </div>
      <div className={style["point-list"]}>
        {props.children.map((element, index) => {
          if (idSelectedCard == index) {
            return (
              <div
                className={`${style["point"]} ${style["point-selected"]}`}
              ></div>
            );
          } else {
            return <div className={`${style["point"]}`}></div>;
          }
        })}

        {/* <div className={style['point']}></div> */}
      </div>
    </div>
  );
}
